module.exports = __webpack_public_path__ + "img/in-use-kati@2x.65938d03.jpg";